/* import __COLOCATED_TEMPLATE__ from './union-pay.hbs'; */
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default SvgIcon.extend({
  width: 22,
  height: 16,
  viewBox: '0 0 22 16',
  colorClass: null
});